import axios from "axios";
import { smartsightAPI } from "../constants/defaultValues";
import jwt from "jsonwebtoken";
import store from "../redux/store";
import { PASSWORD_EXPIRED } from "../redux/actions";

const apiAuth = axios.create({
  baseURL: smartsightAPI,
});

const requestHandler = async (request) => {
  // Modify request here
  let token = localStorage.getItem("jwt");
  
  // Fallback to sessionStorage if localStorage doesn't have the token
  if (!token) {
    token = sessionStorage.getItem("jwt");
  }

  var decodedToken = jwt.decode(token, { complete: true });

  var exdate = new Date().getTime() / 1000;
  let isExpired = false;
  if (decodedToken === null) {
    isExpired = true;
  } else {
    if (decodedToken.payload.exp < exdate) isExpired = true;
  }

  if (isExpired) {
    console.log("is expired");
    let refreshToken = localStorage.getItem("jwtRefresh");
    if (!refreshToken) {
      refreshToken = sessionStorage.getItem("jwtRefresh");
    }
    
    const res = await axios.post(smartsightAPI + "/api/token/refresh/", {
      refresh: refreshToken,
    });
    
    // Store new access token in both locations
    localStorage.setItem("jwt", res.data.access);
    sessionStorage.setItem("jwt", res.data.access);
    
    request.headers["Authorization"] = "Bearer " + res.data.access;
    return request;
  } else {
    request.headers["Authorization"] = "Bearer " + token;
    return request;
  }
};

apiAuth.interceptors.request.use(async (request) => requestHandler(request));

// Response interceptor to catch 403 PASSWORD_EXPIRED from middleware
apiAuth.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 403 &&
      error.response?.data?.error === "PASSWORD_EXPIRED"
    ) {
      // Force show the password reset modal
      store.dispatch({
        type: PASSWORD_EXPIRED,
        payload: {
          reason: error.response.data.force_reset ? "admin" : "expired",
          daysRemaining: 0,
        },
      });

      // Reject with a specific flag so calling code knows not to show generic errors
      const passwordExpiredError = new Error("PASSWORD_EXPIRED");
      passwordExpiredError.isPasswordExpired = true;
      return Promise.reject(passwordExpiredError);
    }

    return Promise.reject(error);
  }
);

export default apiAuth;
